/** Modifier key codes that should not be displayed as the main key */
const MODIFIER_CODES = new Set([
  "ControlLeft",
  "ControlRight",
  "ShiftLeft",
  "ShiftRight",
  "AltLeft",
  "AltRight",
  "MetaLeft",
  "MetaRight",
]);

export const isModifierKey = (code: string): boolean => MODIFIER_CODES.has(code);
